import React from 'react'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { useApiFormNodeOrg } from '../../../../../../api-new/state/content'
import { IconList } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { Purge } from '../../../../../../shared/page/page-purge'
import { useRoleOrgNode } from '../../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const NodeRecycle = ({ nodeID, useApiList, useApiForm, dataContext }) => {
  const { url } = useRouteMatch()

  const apiList = useApiList()

  const apiFormNodeOrg = useApiFormNodeOrg()

  const roleOrgNode = useRoleOrgNode()

  const [error, failure, setError] = useErrorLine()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiFormNodeOrg.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That item was already removed.'), err)
    }

    if (nodeID) await apiList.get(`${nodeID}/deleted`)
    else await apiList.get('deleted')

    if (dataContext) {
      dataContext.reload()
    }
  }

  const handleReady = () => {
    if (nodeID) apiList.get(`${nodeID}/deleted`)
    else apiList.get('deleted')
  }

  const handleDestroyed = () => apiList.init()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiList} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="path" />
            <ColumnText field="datatype" header="Type" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show={roleOrgNode.accessDelete} />
                  <MenuPurge to={`${url}/${row.id}/purge`} show={roleOrgNode.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:purgeID/purge`}>
        <Purge useApiForm={useApiForm} titleParam="name" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
